import React from "react";
import { Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";

const CustomInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
  <div
    className="d-flex align-items-center"
    style={{
      border: "1px solid #A3A3A3",
      borderRadius: 6,
      padding: "0 12px",
      minWidth: 160,
      height: 44,
      background: "#fff",
      color: "#A3A3A3",
      cursor: "pointer",
      fontSize: 16,
    }}
    onClick={onClick}
    ref={ref}
  >
    <span style={{ flex: 1, color: "#A3A3A3" }}>
      {value || "mm/dd/yyyy"}
    </span>
    <FiCalendar style={{ marginLeft: 8, color: "#A3A3A3", fontSize: 20 }} />
  </div>
));

const DateRangePicker = ({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  fromLabel = "From",
  toLabel = "To",
  className = "",
  disabled = false,
}) => {
  const today = new Date();

  return (
    <Row className={`align-items-center g-2 ${className}`}>
      <Col xs="auto">
        <div className="d-flex align-items-center">
          <span className="mb-0 me-2 date-label default-font-styles">{fromLabel}</span>
          <DatePicker
            selected={fromDate}
            onChange={onFromDateChange}
            customInput={<CustomInput placeholder="mm/dd/yyyy" />}
            dateFormat="MM/dd/yyyy"
            maxDate={today} // Disable future dates
          />
        </div>
      </Col>
      <Col xs="auto">
        <div className="d-flex align-items-center">
          <span className="mb-0 me-0 date-label default-font-styles">{toLabel}</span>
          <DatePicker
            selected={toDate}
            onChange={onToDateChange}
            customInput={<CustomInput placeholder="mm/dd/yyyy" />}
            dateFormat="MM/dd/yyyy"
            maxDate={today} // Disable future dates
          />
        </div>
      </Col>
    </Row>
  );
};

export default DateRangePicker;